import React from 'react';

const NotAllowed = () => {
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '50vh',
            backgroundColor: '#ffe5e5',
            color: '#b71c1c',
            textAlign: 'center',
            padding: '30px',
            border: '2px solidrgb(253, 99, 38)',
            borderRadius: '10px',
        },
        heading: {
            fontSize: '2.5rem',
            marginBottom: '15px',
            fontWeight: 'bold',
        },
        paragraph: {
            fontSize: '1.3rem',
            lineHeight: '1.6',
        },
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Accès interdit</h1>
            <p style={styles.paragraph}>
                Désolé, vous n'avez pas les permissions nécessaires pour accéder à cette page. 
                Veuillez contacter l'administrateur si vous pensez que cela est une erreur.
            </p>
        </div>
    );
};

export default NotAllowed;
